import { FWorkflowEventFragment, WorkflowEventSource, WorkflowEventStatus } from '@dashboard/generated/wp/platform';

export function getWorkflowEventStatusLabel(model: FWorkflowEventFragment): string {
  switch (model.status) {
    case WorkflowEventStatus.Canceled:
      return 'Canceled';
    case WorkflowEventStatus.Failed:
      return 'Failed';
    case WorkflowEventStatus.Processing:
      return 'Processing';
    case WorkflowEventStatus.Succeeded:
      return 'Succeeded';
    case WorkflowEventStatus.Pending:
      return 'Pending';
  }
}

export function getWorkflowEventSourceLabel(model: FWorkflowEventFragment): string {
  switch (model.source) {
    case WorkflowEventSource.Preview:
      return 'Preview';
    case WorkflowEventSource.Api:
      return 'API';
    case WorkflowEventSource.SandboxApi:
      return 'API Sandbox';
    case WorkflowEventSource.Trigger:
      return 'Trigger';
  }
}
